import $ from 'jquery';
import Cookier from '../classes/cookier.class';

export default function maintenanceModal() {
  const $modal = $('.js-maintenance-modal');

  if ( !$modal.length ) return;

  const cookie = new Cookier('maintenance_modal_shown');

  $('.js-maintenance-modal-btn').on('click', () => {
    cookie.set(true, 365);
    $modal.remove();
  });
}


// WEBPACK FOOTER //
// ./src/assets/js/project/maintenance-modal.js